import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import RequireAuth from './app/authService/RequireAuth';
import { Layout } from './features/layout/Layout';
import DynamicRoutes from './routes/DynamicRoutes';
import { routeComponentRegistry, ROUTES, toRoutePattern } from './routes/paths';
import AppLoader from './components/AppLoader';

function App() {
	const Login = routeComponentRegistry[toRoutePattern(ROUTES.login)];
	const AuthCallback = routeComponentRegistry[toRoutePattern(ROUTES.authCallback)];
	const AssignedEnvelope = routeComponentRegistry[toRoutePattern(ROUTES.assignedEnvelope)];
	const PublicPortal = routeComponentRegistry[toRoutePattern(ROUTES.publicPortal)];

	return (
		<Routes>
			<Route path={ROUTES.authCallback} element={<Suspense fallback={<AppLoader />}><AuthCallback /></Suspense>} />
			<Route path={ROUTES.authCallbackLegacy} element={<Suspense fallback={<AppLoader />}> <AuthCallback /></Suspense>} />
			<Route path={ROUTES.assignedEnvelope} element={<Suspense fallback={<AppLoader />}>	<AssignedEnvelope /> </Suspense>} />
			<Route path={ROUTES.publicPortal} element={<Suspense fallback={<AppLoader />}>	<PublicPortal /></Suspense>} />
			<Route path="/" element={<Layout />}>
				<Route index element={<Suspense fallback={<AppLoader />}> <Login /> </Suspense>} />
				<Route path={toRoutePattern(ROUTES.login)} element={<Suspense fallback={<AppLoader />}>	<Login /></Suspense>} />
				<Route element={<RequireAuth />}>
					<Route path="/*" element={<DynamicRoutes />} />
				</Route>
			</Route>
		</Routes>
	);
}
export default App;